import { Dialog } from '@mui/material';
import { APPROVAL_TYPES, COMITEE_TYPES } from 'lib/api/approvals/types';
import { getExecutivesAvailableForFactoring } from 'lib/api/factoring';
import { cellFormat } from 'lib/designSystem/Table/cellFormat';
import EnhancedTab from 'lib/designSystem/TabSimulation';
import { validatePermissions } from 'lib/functions/utils';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AuthState } from 'services/redux/authSlice';

import MultiChatWindowContainer from '../../../common/chat';
import Committee from '../../../common/Comittee';
import { ComiteeTabProvider } from '../../../common/Comittee/ComiteeTabProvider';
import FilesModule from './components/FilesModule';
import PaymentModule from './components/PaymentModule';
import EvaluationsModule from './components/RiskModule/components/EvaluationsModule';
import SummaryModule from './components/SummaryModule';

const ExistingOperation = (props: any) => {
  const {
    open,
    setOpen,
    selectedRequest,
    handleEdit,
    parentSetUp,
    refreshOpenRequest,
  } = props;
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const dispatch = useDispatch();
  const startValue = 0;

  const [executivesPortfolio, setExecutivesPortfolio] = useState([]);
  const [executivesAll, setExecutivesAll] = useState([]);

  const fetchExecutives = async () => {
    if (selectedRequest?.stakeholderIdentifier) {
      try {
        const response = await getExecutivesAvailableForFactoring(
          dispatch,
          selectedRequest.stakeholderIdentifier,
        );
        setExecutivesPortfolio(response.usersWithBusinessInPortfolio);
        setExecutivesAll(response.allUsers);
      } catch (error) {
        console.error('Error fetching executives:', error);
      }
    }
  };

  const riskComiteeTabInfo = {
    requestType: APPROVAL_TYPES.CONFIRMING,
    comiteeType: COMITEE_TYPES.RISK,
    requestId: selectedRequest.id,
    comiteeId: selectedRequest.comiteeId,
    canEdit: selectedRequest.status === 'En revisión',
    isRejected: selectedRequest.status === 'Rechazada',
    isActive: ['Completada', 'Activa', 'En giro', 'Aceptada'].includes(
      selectedRequest.status,
    ),
    refreshRequest: () => parentSetUp(selectedRequest.id),
  };

  const operationsComiteeTabInfo = {
    requestType: APPROVAL_TYPES.CONFIRMING,
    comiteeType: COMITEE_TYPES.OPERATIONS,
    requestId: selectedRequest.id,
    comiteeId: selectedRequest.comiteeOperationsId,
    canEdit: selectedRequest.status === 'Aceptada',
    isRejected: selectedRequest.status === 'Rechazada',
    isActive: ['Completada', 'Activa', 'En giro'].includes(
      selectedRequest.status,
    ),
    refreshRequest: () => parentSetUp(selectedRequest.id),
  };

  useEffect(() => {
    if (selectedRequest) {
      void fetchExecutives();
    }
  }, [selectedRequest]);

  const tabs = [
    {
      index: 0,
      label: 'Resumen',
      component: (
        <SummaryModule
          selectedRequest={selectedRequest}
          setOpen={setOpen}
          handleEdit={handleEdit}
          parentSetUp={parentSetUp}
          refreshOpenRequest={refreshOpenRequest}
          executivesPortfolio={executivesPortfolio}
          executivesAll={executivesAll}
        />
      ),
      disabled: !validatePermissions(user, 'financing_confirming_receive'),
    },
    {
      index: 1,
      label: 'Aprobación',
      component: (
        <ComiteeTabProvider info={riskComiteeTabInfo}>
          <Committee />
        </ComiteeTabProvider>
      ),
      disabled: !validatePermissions(user, 'financing_confirming_receive'),
    },
    {
      label: 'Riesgo',
      component: (
        <EvaluationsModule
          selectedRequest={selectedRequest}
          setOpen={setOpen}
        />
      ),
      disabled: !validatePermissions(user, 'financing_confirming_view_risk'),
    },
    {
      index: 3,
      label: 'Operaciones',
      component: (
        <ComiteeTabProvider info={operationsComiteeTabInfo}>
          <Committee />
        </ComiteeTabProvider>
      ),
      disabled: !validatePermissions(
        user,
        'financing_confirming_view_operation',
      ),
    },
    {
      index: 4,
      label: 'Giro',
      component: (
        <PaymentModule
          selectedRequest={selectedRequest}
          setOpen={setOpen}
          parentSetUp={parentSetUp}
        />
      ),
      disabled:
        (selectedRequest.status !== 'En giro' &&
          selectedRequest.status !== 'Activa') ||
        !validatePermissions(user, 'financing_confirming_view_payment'),
    },
    {
      index: 5,
      label: 'Archivos',
      component: (
        <FilesModule
          selectedRequest={selectedRequest}
          setOpen={setOpen}
          requestType="confirming"
        />
      ),
      disabled: !validatePermissions(user, 'financing_confirming_view_files'),
    },
    {
      index: 5,
      label: 'Chat',
      component: (
        <MultiChatWindowContainer
          selectedRequest={selectedRequest}
          requestType="confirming"
          setOpenShoppingCart={setOpen}
        />
      ),
      disabled: !validatePermissions(user, 'financing_confirming_view_chat'),
    },
  ];

  return (
    <Dialog open={open} maxWidth="xl" fullWidth>
      <div style={{ padding: 20, minHeight: 200 }}>
        <EnhancedTab
          title={`Solicitud #${selectedRequest?.id}`}
          startValue={startValue}
          tabs={tabs}
          chip={cellFormat(selectedRequest?.status, 'status-chip')}
        />
      </div>
    </Dialog>
  );
};

export default ExistingOperation;
